// Size constants shared among components

export enum Size {
    XXXSMALL = 'xxxSmall',
    XXSMALL = 'xxSmall',
    XSMALL = 'xSmall',
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large',
    XLARGE = 'xLarge',
    // The CUSTOM size will not set dimensions.
    // Use this in conjunction with a class setting custom dimensions, e.g.
    //   <Icon className={styles.myIconDimensions} size={sizes.CUSTOM} />
    CUSTOM = 'custom'
}

export default Size;
